import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://aromaticos.impultienda.ar/checkout/aromaticos';
type CTAButtonProps = {
  label: string;
  size?: 'md' | 'lg';
  id?: string;
};
export function CTAButton({
  label,
  size = 'lg',
  id
}: CTAButtonProps) {
  const sizeClass = size === 'lg' ? 'py-4 px-6 text-lg sm:text-xl' : 'py-3.5 px-5 text-base';
  return <a id={id} href={CHECKOUT_URL} className={`animate-pulse-glow group relative flex w-full items-center justify-center gap-2 rounded-full bg-[#7c6aa8] font-bold uppercase tracking-wide text-white shadow-lg shadow-[#7c6aa8]/30 transition-transform duration-200 hover:scale-[1.02] hover:bg-[#6a5a95] active:scale-95 ${sizeClass}`} data-id="element-72" data-mp="2tyum016o6ivk">
      <span className="leading-tight text-center" data-id="element-73" data-mp="2ys5x4eiillta">{label}</span>
      <ArrowRightIcon className="w-5 h-5 shrink-0 transition-transform group-hover:translate-x-1" data-id="element-74" data-mp="3cqvs9olrxbf0" />
    </a>;
}